export const messages = {
  en: {
    chainInoutOrder: {
      queryCondition: 'Query Conditions',
      personNamePlaceholder: 'Please enter user name',
      orderIdPlaceholder: 'Please enter order number',
      supplierPlaceholder: 'Please select supplier',
      query: 'Query',
      orderTitle: 'Procurement Orders',
      supplier: 'Supplier',
      orderId: 'Order Number',
      status: 'Status',
      contactPerson: 'Contact Person',
      contactPhone: 'Contact Phone',
      operation: 'Operation',
      detail: 'Detail'
    }
  },
  zh: {
    chainInoutOrder: {
      queryCondition: '查询条件',
      personNamePlaceholder: '请填写用户名称',
      orderIdPlaceholder: '请填写订单号',
      supplierPlaceholder: '请选择供应商',
      query: '查询',
      orderTitle: '集采订单',
      supplier: '供应商',
      orderId: '订单编号',
      status: '状态',
      contactPerson: '联系人',
      contactPhone: '联系电话',
      operation: '操作',
      detail: '详情'
    }
  }
}